













































































import { defineComponent, type PropType } from "vue-demi";
import GGGroup from "./GGGroup/GGGroup.vue";
import GGShrinkGrid from "./GGShrinkGrid.vue";
import GGWideGrid from "./GGWideGrid.vue";
import GGCategoryGrid from "./GGCategoryGrid.vue";
import GGBrandGrid from "../grid-generation/GGBrandGrid.vue";
import ViewportToogle from "../ViewportToogle.vue";
import GGProduct from "./GGProduct.vue";
import GGProductPromo from "./GGProductPromo.vue";
import GGProductSliderGrid from "./GGProductSliderGrid.vue";
import factoids from "../factoid";
import type { PageData } from "@constructor/shared-entity/type";
import type { UserCart } from "../../type/UserCart";
import type { SectionMeta } from "../../type/SectionMeta";
import getValueForProp from "../../helper/getValueForProp";

export default defineComponent({
  name: "GGDefaultSection",
  components: {
    GGGroup,
    GGShrinkGrid,
    GGWideGrid,
    GGCategoryGrid,
    GGBrandGrid,
    ViewportToogle,
    GGProduct,
    GGProductPromo,
    GGProductSliderGrid,
    ...factoids,
  },
  props: {
    data: {
      type: Object as PropType<PageData>,
      required: true,
    },
    userCart: {
      type: Object as PropType<UserCart>,
      required: true,
    },
    meta: {
      type: Object as PropType<SectionMeta>,
      default: () => ({}),
    },
  },
  emits: {
    "cart-add": (_: string) => true,
    "cart-remove": (_: string) => true,
    "auth-needed": () => true,
  },
  computed: {
    showProductSliderCard() {
      return (
        getValueForProp("enableSliderCard", this.data.template.prop) ||
        undefined
      );
    },
  },
});
